// frontend-react/src/utils/notifyReviewComplete.ts
// 審閱完成通知：Browser Notification + 標題閃爍

let titleFlashTimer: ReturnType<typeof setInterval> | null = null;
const originalTitle = document.title;

/** 請求瀏覽器通知權限（在使用者點擊「開始審閱」時呼叫） */
export function requestNotificationPermission() {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
}

/** 審閱完成時呼叫 */
export function notifyReviewComplete(itemCount: number, fileName: string) {
  const title =
    itemCount === 0 ? 'AI 審閱完成 — 無待處理項目' : `AI 審閱完成 — ${itemCount} 項建議`;

  // 1. Browser Notification（不論前景/背景都發送）
  if ('Notification' in window && Notification.permission === 'granted') {
    const notification = new Notification(title, { body: fileName });
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
  }

  // 2. 標題閃爍（頁面不在前景時）
  if (document.hidden) {
    startTitleFlash();
  }
}

function startTitleFlash() {
  if (titleFlashTimer) return;

  let show = true;
  titleFlashTimer = setInterval(() => {
    document.title = show ? '✅ 審閱完成！' : originalTitle;
    show = !show;
  }, 1000);

  // 使用者切回頁面時停止閃爍
  const stopFlash = () => {
    if (titleFlashTimer) {
      clearInterval(titleFlashTimer);
      titleFlashTimer = null;
    }
    document.title = originalTitle;
    document.removeEventListener('visibilitychange', onVisible);
  };

  const onVisible = () => {
    if (!document.hidden) stopFlash();
  };
  document.addEventListener('visibilitychange', onVisible);
}
